import { render, staticRenderFns } from "./BranchUpload.vue?vue&type=template&id=0c9e01de&scoped=true"
import script from "./BranchUpload.vue?vue&type=script&lang=js"
export * from "./BranchUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e01de",
  null
  
)

export default component.exports